"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepositCipFailureReason = void 0;
var DepositCipFailureReason;
(function (DepositCipFailureReason) {
    DepositCipFailureReason["manualFraudReview"] = "manual_fraud_review";
    DepositCipFailureReason["cipVerificationFailed"] = "cip_verification_failed";
})(DepositCipFailureReason || (exports.DepositCipFailureReason = DepositCipFailureReason = {}));
